import React from 'react'
const Spinner = () => {
  return (
    <div className='spinner-main'>
      <div className="custom-loader"></div>
      <p className='loading'>Loading...</p>
    </div>
  )
}

export default Spinner
